(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-inventory-live')) {
    class ProductInventoryLive extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(
            this.querySelector('[data-inventory-data]').textContent
          );
        } catch (e) {
          this.variants = {};
        }

        this.iconEl = this.querySelector('[data-inventory-icon]');
        this.textEl = this.querySelector('[data-inventory-text]');

        this.onVariantUpdate = (event) => {
          const id = event.detail?.resource?.id;
          if (id) this.update(id);
        };

        // Horizon's variant picker event
        document.addEventListener('variant:update', this.onVariantUpdate);

        // Fallback: read ?variant= from the URL after an option change / back button
        this.onFallback = () => {
          setTimeout(() => {
            const id = new URL(window.location.href).searchParams.get('variant');
            if (id) this.update(id);
          }, 300);
        };
        document.addEventListener('change', this.onFallback);
        window.addEventListener('popstate', this.onFallback);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariantUpdate);
        document.removeEventListener('change', this.onFallback);
        window.removeEventListener('popstate', this.onFallback);
      }

      update(variantId) {
        const data = this.variants[String(variantId)];
        if (!data || !this.iconEl || !this.textEl) return;

        this.iconEl.classList.remove(
          'product-inventory__icon-low',
          'product-inventory__icon-in_stock',
          'product-inventory__icon-out_of_stock'
        );
        this.iconEl.classList.add('product-inventory__icon-' + data.status);

        this.textEl.textContent = data.text;
      }
    }

    customElements.define('product-inventory-live', ProductInventoryLive);
  }
  } catch(e) { console.error(e); }
})();

})();
